import { type SidebarItem } from "./sidebar";

import { t } from '@/utils/i18n';

export const getSidebarItems = ({ isAffiliate = false }: { isAffiliate?: boolean } = {}): SidebarItem[] => {
    const items: SidebarItem[] = [
        {
            key: 'tutorial-video',
            href: '/tutorial-video',
            icon: 'mdi:school-outline',
            title: t('sidebar.sidebar_1'),
        },
        {
            key: 'telegram-bot',
            href: '/telegram-bot',
            icon: 'bxl:telegram',
            title: t('sidebar.sidebar_11'),
        },
        {
            key: 'schedule',
            href: '/schedule',
            icon: 'solar:calendar-outline',
            title: t('sidebar.sidebar_2'),
        },
        {
            key: 'players',
            href: '/players',
            icon: 'solar:user-outline',
            title: t('sidebar.sidebar_3'),
        },
        {
            key: 'teams',
            href: '/teams',
            icon: 'solar:users-group-two-rounded-outline',
            title: t('sidebar.sidebar_4'),
        },
        {
            key: 'leagues',
            href: '/leagues',
            icon: 'material-symbols:trophy-outline',
            title: t('sidebar.sidebar_5'),
        },
        {
            href: '/referees',
            key: 'referees',
            icon: 'mdi:whistle-outline',
            title: t('sidebar.sidebar_6'),
        },
        {
            key: 'finder',
            href: '/finder-player',
            icon: 'mdi:search',
            title: t('sidebar.sidebar_7'),
        },
        {
            key: 'my-account',
            href: '/my-account',
            icon: 'solar:user-circle-outline',
            title: t('sidebar.sidebar_8'),
        },
    ];

    if (isAffiliate) {
        items.push({
            key: 'affiliate-dashboard',
            href: '/affiliate-dashboard',
            icon: 'solar:chart-square-outline',
            title: t('sidebar.sidebar_12'),
        });
    }

    return items;
}
